import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface TutorState {
  signUpData: {
    phone: string;
    email: string;
    password: string;
    userType: string;
    terms?: boolean;
  };
  basicInfo: {
    firstName: string;
    lastName: string;
    school: string;
    schoolId: string;
    grade: string;
    languageSpoken: string;
    subjectsTaught: string;
    weightedGPA: string;
    bio: string;
  };
  parentInfo: {
    firstName: string,
    lastName: string,
    phone: string,
    email: string,
  };
  academicInfo: Array<{
    degree: string;
    university: string;
    grade: string;
    certificates: string;
    passingYear: string;
    issuedBy: string;
    subjectsTaught: string;
    weightedGPA: string;
  }>;
}

const initialState: TutorState = {
  signUpData: {
    phone: '',
    email: '',
    password: '',
    userType: 'tutor', // Default to tutor
  },
  basicInfo: {
    firstName: '',
    lastName: '',
    school: '',
    schoolId: '',
    grade: '',
    weightedGPA: '',
    languageSpoken: '',
    subjectsTaught: '',
    bio: '',
  },
  parentInfo: {
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
  },
  academicInfo: [
    {
      degree: '',
      university: '',
      grade: '',
      certificates: '',
      passingYear: '',
      issuedBy: '',
      subjectsTaught: '',
      weightedGPA: '',
    },
  ],
};

export const tutorSlice = createSlice({
  name: 'tutor',
  initialState,
  reducers: {
    updateSignUpData: (
      state,
      action: PayloadAction<Partial<TutorState['signUpData']>>,
    ) => {
      state.signUpData = {...state.signUpData, ...action.payload};
    },
    updateBasicInfo: (
      state,
      action: PayloadAction<Partial<TutorState['basicInfo']>>,
    ) => {
      state.basicInfo = {...state.basicInfo, ...action.payload};
    },
    updateParentInfo: (
      state,
      action: PayloadAction<Partial<TutorState['parentInfo']>>,
    ) => {
      state.parentInfo = {...state.parentInfo, ...action.payload};
    },
    updateAcademicInfo: (
      state,
      action: PayloadAction<Partial<TutorState['academicInfo'][0]>>,
    ) => {
      state.academicInfo[0] = {...state.academicInfo[0], ...action.payload};
    },
    resetTutorData: state => {
      state.signUpData = initialState.signUpData;
      state.basicInfo = initialState.basicInfo;
      state.parentInfo = initialState.parentInfo;
      state.academicInfo = initialState.academicInfo;
    },
  },
});

export const {
  updateSignUpData,
  updateBasicInfo,
  updateParentInfo,
  updateAcademicInfo,
  resetTutorData,
} = tutorSlice.actions;

export default tutorSlice.reducer;
